import { useRef, useState } from "react";

const STAGGER_DELAY_MS = 50;

const RadialFeatureCard = ({
  feature,
  style,
  isVisible,
  index,
  onMouseEnter,
  onMouseLeave,
  onClick,
  isSelected,
}) => {
  const cardRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const { left, top, width, height } = cardRef.current.getBoundingClientRect();
    const x = e.clientX - left - width / 2;
    const y = e.clientY - top - height / 2;
    const rotateY = (x / (width / 2)) * 15;
    const rotateX = -(y / (height / 2)) * 15;
    setTilt({ x: rotateX, y: rotateY });
  };

  const handleMouseEnterInternal = () => {
    setIsHovering(true);
    onMouseEnter(feature);
  };

  const handleMouseLeaveInternal = () => {
    setIsHovering(false);
    setTilt({ x: 0, y: 0 });
    onMouseLeave();
  };

  const scale = isSelected || isHovering ? 1.1 : 1;
  const z = !isSelected && isHovering ? 20 : 0;

  const combinedTransform = `${style.transform} perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg) translateZ(${z}px) scale(${scale})`;

  return (
    <div
      ref={cardRef}
      role="button"
      tabIndex={0}
      className={`
        group absolute
        w-44 h-44 md:w-48 md:h-48
        transition-transform duration-200 ease-out
        ${isVisible ? "opacity-100" : "opacity-0"}
      `}
      style={{
        transform: combinedTransform,
        transitionProperty: "transform, opacity",
        opacity: isVisible ? 1 : 0,
        transitionDelay: `${index * STAGGER_DELAY_MS}ms`,
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeaveInternal}
      onClick={() => onClick(feature)}
      onMouseEnter={handleMouseEnterInternal}
    >
      <div
        className={`
          flex flex-col items-center justify-center p-2 w-full h-full rounded-full shadow-xl border
          bg-white/70 backdrop-blur-md 
          transition-all duration-300 ease-out-expo
          active:scale-95
          ${isSelected ? "border-sky-400" : "border-white/30"}
        `}
      >
        <div
          className={`
            absolute inset-0 rounded-full border-2 border-sky-400 transition-all duration-300 ease-out-expo
            ${isSelected ? "scale-100 opacity-100" : "scale-110 opacity-0"}
          `}
        ></div>
        <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-sky-500 text-white rounded-full text-3xl shadow-lg transition-transform duration-300 ease-out-expo group-hover:scale-110 group-hover:-translate-y-1">
          {feature.icon}
        </div>
        <h4 className="font-bold text-slate-700 text-center text-sm md:text-md leading-tight mt-2">
          {feature.title}
        </h4>
      </div>
    </div>
  );
};

export default RadialFeatureCard;
